import { Pipe, PipeTransform } from '@angular/core';
import { DataTableColDef } from '../interfaces/col-def.interface';

@Pipe({
  name: 'colColor'
})
export class ColumnColorPipe implements PipeTransform {
  transform(item: any, column: DataTableColDef): string {
    if (column.color) {
      if (typeof column.color === 'string') {
        return column.color;
      } else {
        return column.color(item);
      }
    } else {
      return '';
    }
  }
}
